<template>
  <div class="serch_border">
    <div class="serchform">
      投资领域：
      <a-tag :class="{'tag-active':''==investmentFields}" @click="postSerchData({investmentField:''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==investmentFields}" @click="postSerchData({investmentField:item.dictValue})" v-for="(item,key) in options.investmentField" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="cont_body">
    <div v-for="(item,key) in optionsData" :key="key" @click="goMore('/finance/investorCenter/page','sy',item.id)" class="list_cont">
      <div class="list_img">
        <img :src="getImg(item.headImg)" alt="">
      </div>
      <div class="list_cont_body">
        <h4>{{ item.name }} <span>· <dict-render :dict-obj="dictObjs['position']"
          :text="item.position"></dict-render></span></h4>
        <P>投资领域：
          <dict-render :dict-obj="dictObjs['investmentField']"
          :text="item.majorField"></dict-render>
        </P>
      </div>
    </div>
  </div>
  <a-pagination style="clear:both;float:right" v-model:current="current" :total="10" show-less-items />
</template>
<script>
import { dictMixin } from "@/mixins";
import {financeAdvisorWeb} from "@/api/finance";
import {common_controller} from "@/api/commonService";
import {file_service} from "@/api/adminService";
import DictRender from "@/components/other/DictRender";
import {financeDict} from "@/config/variableConfig"
export default {
  name: 'investor',
  components: { DictRender },
  mixins: [dictMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 查询条件
      investmentFields: '',// 投资领域
      financeDict,
      options:null,
      dictNames: 'investmentField,position,invest_limits',
      optionsData:null,
    }
  },
  mounted() {
      this.getDict();
      this.getSerchData();
  },
	methods: {
    postSerchData(val){
        if(val.investmentField||val.investmentField==''){
          this.investmentFields = val.investmentField
        }
      this.getSerchData()
      
    },
    getSerchData(){
      this.getAction({
            url: financeAdvisorWeb.pageList,
            params: {
              pageNum: 1,
              pageSize: 10,
              majorField: this.investmentFields
            },  
        }).then(res => {
          this.optionsData = res.records
        }).catch((e) => {
          console.log(e)
        })
    },
    getDict(){
        this.getAction({
            url:common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: "invest_limit,investmentField"
            }
        }).then(res=>{
            this.options = res
        })
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url,key,id) {
			this.$router.push({path: url, query: {type: key,queryData: id}})
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  width: 592px;
  margin-bottom: 16px;
  &:nth-child(odd){
    margin-right: 16px;
  }
  .list_img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 10px 20px 25px;
    flex: 1;
    display: flex;
    align-items: center;
    img{
      width:100%
    }
  }
  .list_cont_body{
    flex: 5;
  }
}
</style>